import { render, staticRenderFns } from "./amazonAds.vue?vue&type=template&id=652a99f4&scoped=true"
import script from "./amazonAds.vue?vue&type=script&lang=js"
export * from "./amazonAds.vue?vue&type=script&lang=js"
import style0 from "./amazonAds.vue?vue&type=style&index=0&id=652a99f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a99f4",
  null
  
)

export default component.exports